import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <TopicsSection />
        <AppSection />
        <AboutSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <MediaSection />
        <CarouselSection />
        <FAQSection />
        <IndexSection />
        <FeaturesSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}